module.exports = __webpack_public_path__ + "img/new_logo.74b56203.png";